<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="cbp-spmenu-push">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="banner-info">
          <span>品質と安全</span>
        </div>
      </div>
    </div>
    <!-- banner-bottom -->
    <section>
      <!-- 品质管理 -->
      <section id="pzgl">
        <div class="container gradient-background">
          <div class="row">
            <div class="col-lg-12 rzTop">
              <h1><span>品質管理</span></h1>
              <p class="rzp">
                華胤の品質方針は、妥協しない精神を堅持し、顧客の要求および技術規格に従って、製品の継続的改善に努め、より良い品質を追求し、顧客が指名した監督チームと密接に協力して、主管官庁が定めた規格基準に適合することを確実にし、顧客の要求を超えることを目標とすることです。<br /><br />
                華胤の品質管理の重点は顧客志向にあり、経営層の高度な注目を有し、全員参加の方法でより良い成果を得ることにあります。実行面において、華胤は合理的な作業環境の構築に努め、長期的に5S管理制度を推進し、内部資源を最大限に活用できるようにしています。品質検査部門の人員と連携し、現場に入り込んで是正指導を行い、問題を第一時間で発見し解決することを徹底しています。華胤は厳格な工程管理と品質管理を重視し、原料から製品までのすべての製造細部にわたって貫徹しています。私たちは顧客と共に努力し、華胤が製造するすべての部品が完璧に達するようにしています。
              </p>
              <div class="container-fluid">
                <div
                  class="col-lg-3 col-xs-6"
                  v-for="(item, index) in pzglList"
                  :key="index"
                >
                  <div class="pzglImg">
                    <img
                      :src="item.image"
                      alt=""
                      style="width: 100%; height: 100%"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 產品質量 -->

          <div class="row" id="cpzl">
            <div class="col-lg-12 cpTop">
              <h1><span>製品品質</span></h1>
            </div>
          </div>
          <div class="container-fluid">
            <carousel-3d
              :controlsVisible="true"
              :width="cWidth"
              :height="cHeight"
              :display="cNum"
              :space="280"
            >
              <slide
                v-lazy-container="{ selector: 'img' }"
                :index="index"
                v-for="(item, index) in cpzlList"
                :key="index"
              >
                <div class="col-lg-12 col-xs-12">
                  <h2 class="slideh2">{{ item.title }}</h2>
                  <div class="col-lg-6">
                    <img :data-src="item.img1" class="slideImg" alt="" />
                    <p class="slideP">{{ item.txt1 }}</p>
                  </div>
                  <div class="col-lg-6">
                    <img :data-src="item.img2" class="slideImg" alt="" />
                    <p class="slideP">{{ item.txt2 }}</p>
                  </div>
                </div>
                <p
                  class="slideP"
                  style="
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%, 0);
                  "
                >
                  第{{ index + 1 }}ページ/全23ページ
                </p>
              </slide>
            </carousel-3d>
          </div>

          <!-- 產品包裝 -->
          <div class="row" id="cpbz">
            <div class="col-lg-12 rzTop">
              <h1><span>梱包・輸送</span></h1>
              <p class="rzp">
                お客様が受け取るすべての部品が出荷時と同じ完璧な状態であるように、華胤は輸送距離、方法、およびお客様の要求に基づいて製品の包装を行っています。優れた包装により、部品は厳しい輸送過程でも保護され、これにより私たちの製品はどこへでも出荷可能です。私たちの製品は、アメリカ、日本、ヨーロッパ、オーストラリア、韓国、タイ、南アフリカ、ハイチ、アンゴラなど、30以上の国々に輸送されたことがあります。
              </p>
              <div class="container-fluid">
                <div
                  class="col-lg-4 col-xs-6"
                  v-for="(item, index) in cpbzList"
                  :key="index"
                >
                  <div class="cpbzImg">
                    <img
                      :src="item.image"
                      alt=""
                      style="width: 100%; height: 100%"
                    />
                  </div>
                  <div class="cpp">
                    <p>{{ item.text }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 安全政策 -->
          <div class="row" id="aqzc">
            <div class="col-lg-12 rzTop">
              <h1><span>安全管理</span></h1>
              <p class="rzp">
                華胤グループは「労働災害ゼロ」を目標とし、職業安全規則および国際基準を厳格に遵守し、AISC、AWS、CWB
                W47.1/ CSA A660-10、EN 1090、ISO 3834、ISO 45001、ISO 9001、ISO
                14001、中国鋼構一級資格および日本JSAなど多くの権威ある認証を取得しています。私たちは安全方針を実施し、工場全員が正しくPPE（個人防護具）を着用することを求め、教育訓練、現場監査および自動点検を推進しています。厳格な安全管理と卓越した品質により、国際総合請負業者から「安全作業時間賞」および「優秀鋼構造サプライヤー」を複数回受賞し、世界中のエンジニアリングで信頼される協力パートナーとなっています。
              </p>
            </div>
            <div class="col-lg-12" style="text-align: center">
              <img src="@/components/img/pzyaq/aqzc.jpg" alt="" class="aqImg" />
            </div>
          </div>
        </div>
      </section>
      <!-- 邮箱 -->
      <div class="mailbg">
        <to-mail button-text="お問い合わせ"></to-mail>
      </div>
      <!-- 小滾輪 -->
      <div id="ss_menu">
        <div>
          <i
            ><a @click="forId('pzgl')">品質<br />管理</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('cpzl')">製品<br />品質</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('cpbz')">梱包<br />輸送</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('aqzc')">安全<br />管理</a></i
          >
        </div>
        <div class="menu">
          <div class="share" id="ss_toggle" data-rot="180">
            <div class="circle"></div>
            <div class="bar"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pzglList: [
        {
          image: require('@/components/img/pzyaq/pzgl1.jpg'),
        },
        {
          image: require('@/components/img/pzyaq/pzgl2.jpg'),
        },
        {
          image: require('@/components/img/pzyaq/pzgl3.jpg'),
        },
        {
          image: require('@/components/img/pzyaq/pzgl4.jpg'),
        },
      ],
      cpzlList: [
        {
          title: '原材料管理',
          img1: require('@/components/img/pzyaq/cpdb1.jpg'),
          txt1: 'よくある質問：原材料が適当に置かれ、異なる素材の区別がされていないため、作業員は簡単に間違って取ったり、誤って使ったりしてしまいます。',
          img2: require('@/components/img/pzyaq/cpdb1-1.jpg'),
          txt2: '華胤：適切な倉庫スペースがあり、材料の取り扱いが整っている',
        },
        {
          title: '顔色およびバーコード管理',
          img1: require('@/components/img/pzyaq/cpdb2.jpg'),
          txt1: 'よくある質問：材料に表示がなく、作成時に間違いやすい。',
          img2: require('@/components/img/pzyaq/cpdb2-1.jpg'),
          txt2: '華胤：異なる鋼種は色で塗り分けて区別する',
        },
        {
          title: '原材料サプライヤー',
          img1: require('@/components/img/pzyaq/cpdb3.jpg'),
          txt1: 'よくある質問：表示のない製鋼所を選ぶことは、“三無”製品に該当します。',
          img2: require('@/components/img/pzyaq/cpdb3-1.jpg'),
          txt2: '華胤：国内の大手鋼鉄メーカーを選ぶ：首鋼、馬鋼など。',
        },
        {
          title: '鋼板切断の品質',
          img1: require('@/components/img/pzyaq/cpdb4.jpg'),
          txt1: 'よくある質問：切断面が凹凸で、ギザギザの欠陥があり、外観の品質が非常に悪い。',
          img2: require('@/components/img/pzyaq/cpdb4-1.jpg'),
          txt2: '華胤: CNC切断、切断面の品質は良好です。',
        },
        {
          title: '自由エッジ面取り研磨',
          img1: require('@/components/img/pzyaq/cpdb5.jpg'),
          txt1: 'よくある質問：自由に面取りをせず研磨した場合、バリが除去されていません。',
          img2: require('@/components/img/pzyaq/cpdb5-1.jpg'),
          txt2: '華胤：すべての切断面および自由端を面取りして研磨する。',
        },
        {
          title: 'アークスタート板',
          img1: require('@/components/img/pzyaq/cpdb6.jpg'),
          txt1: 'よくある質問：アーク板が装着されていません。',
          img2: require('@/components/img/pzyaq/cpdb6-1.jpg'),
          txt2: '華胤：BH埋弧溶接継手にアーク引き板を装着する。',
        },
        {
          title: '面取り',
          img1: require('@/components/img/pzyaq/cpdb7.jpg'),
          txt1: 'よくある質問：ボルト穴にバリがあり、塗装の付着力に影響する',
          img2: require('@/components/img/pzyaq/cpdb7-1.jpg'),
          txt2: '華胤：すべてのボルト穴は面取りして研磨する',
        },
        {
          title: '過ハンダ孔面取り',
          img1: require('@/components/img/pzyaq/cpdb8.jpg'),
          txt1: 'よくある質問：はんだ穴を開けていない、三つのはんだ継ぎ目が交差する部分の成形が非常に悪く、アークピットの欠陥があります',
          img2: require('@/components/img/pzyaq/cpdb8-1.jpg'),
          txt2: '華胤：主な溶接線の交差部分には溶け穴を開けており、応力集中の発生を防ぎ、かつ隅肉溶接も適合しています。',
        },
        {
          title: '位置決め溶接',
          img1: require('@/components/img/pzyaq/cpdb9.jpg'),
          txt1: 'よくある質問：工法の要求はなく、自由にスポット溶接を行ってください',
          img2: require('@/components/img/pzyaq/cpdb9-1.jpg'),
          txt2: '華胤：工芸上の要求としてスポット溶接で固定し、長さは100〜150、間隔は300〜400が必要です',
        },
        {
          title: '埋弧溶接',
          img1: require('@/components/img/pzyaq/cpdb10.jpg'),
          txt1: 'よくある質問：溶接角の大きさが均一でない、溶接ビードと母材の間が滑らかに移行せず、有効に融け合っていない',
          img2: require('@/components/img/pzyaq/cpdb10-1.jpg'),
          txt2: '華胤：溶接の継ぎ目は滑らかに移行しており、外観が非常に美しく、溶接の欠陥は全くありません',
        },
        {
          title: '溶接線内部の断面',
          img1: require('@/components/img/pzyaq/cpdb11.jpg'),
          txt1: 'よくある質問：溶接部の内部断面を確認したところ、溶融が見られない',
          img2: require('@/components/img/pzyaq/cpdb11-1.jpg'),
          txt2: '華胤：溶接部の内部断面図は完全に溶融している。',
        },
        {
          title: '鋼構造の矯正',
          img1: require('@/components/img/pzyaq/cpdb12.jpg'),
          txt1: 'よくある質問：溶接後に歪みが生じ、補正処理を行わない',
          img2: require('@/components/img/pzyaq/cpdb12-1.jpg'),
          txt2: '華胤：矯正後、規範の要件を満たしている',
        },
        {
          title: '切断',
          img1: require('@/components/img/pzyaq/cpdb13.jpg'),
          txt1: 'よくある問題：手作業での切断がまっすぐではなく、切り込みの深さが大きく、残渣が除去されていない',
          img2: require('@/components/img/pzyaq/cpdb13-1.jpg'),
          txt2: '華胤：機械による切断は平らで滑らか、欠陥がありません',
        },
        {
          title: 'プラットフォーム梁の製作',
          img1: require('@/components/img/pzyaq/cpdb14.jpg'),
          txt1: 'よくある質問：手作業で切断しており、R角がありません',
          img2: require('@/components/img/pzyaq/cpdb14-1.jpg'),
          txt2: '華胤：外露R角の滑らかなトランジション',
        },
        {
          title: 'アーク溶接自動溶接（SAW）',
          img1: require('@/components/img/pzyaq/cpdb15.jpg'),
          txt1: 'よくある質問：国内のアーク溶接機で溶接した品質が非常に悪い',
          img2: require('@/components/img/pzyaq/cpdb15-1.jpg'),
          txt2: '華胤：輸入された埋弧溶接機は非常に先進的で、溶接した構造の品質も優れています',
        },
        {
          title: '破口面切断',
          img1: require('@/components/img/pzyaq/cpdb16.jpg'),
          txt1: 'よくある質問：切断面がまっすぐではなく、欠けがある',
          img2: require('@/components/img/pzyaq/cpdb16-1.jpg'),
          txt2: '華胤：切断面は平らで滑らかです。',
        },
        {
          title: '組立工法',
          img1: require('@/components/img/pzyaq/cpdb17.jpg'),
          txt1: 'よくある質問：組み立て工法の要件はありません',
          img2: require('@/components/img/pzyaq/cpdb17-1.jpg'),
          txt2: '華胤：製造工程に従って溝を切り込み、研磨して組み立て',
        },
        {
          title: 'SMAW溶接継ぎ目',
          img1: require('@/components/img/pzyaq/cpdb18.jpg'),
          txt1: 'よくある質問：溶接部が粗く、成形が不良です',
          img2: require('@/components/img/pzyaq/cpdb18-1.jpg'),
          txt2: '華胤：溶接部は滑らかで整っている',
        },
        {
          title: '多道溶接',
          img1: require('@/components/img/pzyaq/cpdb19.jpg'),
          txt1: 'よくある質問：溶接部と溶接部の間が融合していない',
          img2: require('@/components/img/pzyaq/cpdb19-1.jpg'),
          txt2: '華胤：溶接部と溶接部の間は滑らかで整っている',
        },
        {
          title: 'GMAW溶接',
          img1: require('@/components/img/pzyaq/cpdb20.jpg'),
          txt1: 'よくある質問：溶接部の成形が粗く、外観に欠陥がある',
          img2: require('@/components/img/pzyaq/cpdb20-1.jpg'),
          txt2: '華胤：溶接部の成形は美しく、滑らかに遷移しています',
        },
        {
          title: '溶接・研磨による錆取り',
          img1: require('@/components/img/pzyaq/cpdb21.jpg'),
          txt1: 'よくある質問：錆取りのレベルが不十分です',
          img2: require('@/components/img/pzyaq/cpdb21-1.jpg'),
          txt2: '華胤: 錆除去レベルはSa2 ½に達している',
        },
        {
          title: '塗装品質',
          img1: require('@/components/img/pzyaq/cpdb22.jpg'),
          txt1: 'よくある質問：塗料が複数箇所で傷んでおり、塗料の厚みも不均一です',
          img2: require('@/components/img/pzyaq/cpdb22-1.jpg'),
          txt2: '	華胤：塗装は均一で、外観に欠陥はありません',
        },
        {
          title: '摩擦面用シール保護',
          img1: require('@/components/img/pzyaq/cpdb23.jpg'),
          txt1: 'よくある質問：摩擦面はシートを貼らず、塗装する',
          img2: require('@/components/img/pzyaq/cpdb23-1.jpg'),
          txt2: '華胤：摩擦面は規格に従ってシールを貼る',
        },
      ],
      cpbzList: [
        {
          image: require('@/components/img/pzyaq/cpbz1.jpg'),
          text: '貨物船輸送',
        },
        {
          image: require('@/components/img/pzyaq/cpbz2.jpg'),
          text: '大物の梱包',
        },
        {
          image: require('@/components/img/pzyaq/cpbz3.jpg'),
          text: 'コンテナ梱包',
        },
        {
          image: require('@/components/img/pzyaq/cpbz4.jpg'),
          text: '小物の梱包',
        },
        {
          image: require('@/components/img/pzyaq/cpbz5.jpg'),
          text: 'モジュールパッケージング',
        },
        {
          image: require('@/components/img/pzyaq/cpbz6.jpg'),
          text: '特別パッケージ',
        },
      ],
    }
  },
  methods: {
    // 調用全局方法，滾動指定id
    forId(tId) {
      console.log(tId)
      this.$store.dispatch('toID', tId)
    },
    changeHeight() {
      if (document.body.clientWidth >= 2000) {
        this.cWidth = 1300
        this.cHeight = 700
        this.cNum = 5
      } else if (
        document.body.clientWidth > 1400 &&
        document.body.clientWidth < 2000
      ) {
        this.cWidth = 1000
        this.cHeight = 650
        this.cNum = 3
      } else if (
        document.body.clientWidth >= 768 &&
        document.body.clientWidth <= 1400
      ) {
        this.cWidth = 600
        this.cHeight = 500
        this.cNum = 3
      } else if (document.body.clientWidth < 768) {
        this.cWidth = 1000
        this.cHeight = 1450
        this.cNum = 3
      }
    },
  },
  mounted() {
    // 獲取高度
    window.onresize = () => {
      this.changeHeight()
    }
  },
  created() {
    this.changeHeight()
  },
  updated() {
    if (this.scrollToElement) {
      this.scrollToElement()
      this.scrollToElement = null
    }
  },
}
</script>

<style scoped>
/* 榮譽圖片註釋設置 */
.cbp-spmenu-push {
  overflow-x: hidden;
  position: relative;
  left: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.cbp-spmenu-push .banner {
  background: url(@/components/img/pzyaq/1.jpg) 0px 0px no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  height: 500px;
  position: relative;
  width: 100%;
  background-size: 100% 100%;
}

/*-- banner-info --*/
.banner-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.banner-info span {
  font-size: 50px;
  color: #fff;
  padding: 0 10px;
  margin: 0 auto;
  line-height: normal;
  background: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}
/***** Lexi *****/
/* 小滾輪 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px !important;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #415160;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 13px;
  text-align: center;
  background: #415160;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #2a2f34;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: 0px;
  left: -160px;
}

#ss_menu div:nth-child(2) {
  top: -80px;
  left: -138.56406px;
}

#ss_menu div:nth-child(3) {
  top: -138.56406px;
  left: -80px;
}

#ss_menu div:nth-child(4) {
  top: -160px;
  left: 0px;
}

.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.hspan,
.hspan2 {
  display: inline-block;
  position: relative;
  padding: 10px 20px;
  font-size: 30px;
  font-weight: 600;
}

.hspan::after,
.hspan2::after {
  content: '';
  position: absolute;
  bottom: 0;
  width: 150%;
  height: 3px;
  background-color: #8e8e8b;
  transition: width 0.3s ease;
}
.hspan::after {
  left: 13%;
}
.hspan2::after {
  left: 8%;
}
.pzglImg {
  position: relative; /* 父容器设为相对定位 */
  width: 100%;
  height: 30vw; /* 按需设置高度 */
  overflow: hidden; /* 防止图片溢出 */
  margin: 15px 0;
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

.cpbzImg {
  position: relative; /* 父容器设为相对定位 */
  width: 100%;
  height: 18vw; /* 按需设置高度 */
  overflow: hidden; /* 防止图片溢出 */
  margin: 0;
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

.cpp {
  margin: 20px 0;
  text-align: center;
  font-size: 25px;
}

.container-fluid {
  margin: 70px auto;
}

.rzTop {
  margin: 90px 0;
  text-align: center;
}
.aqTop {
  margin: 0 0 90px 0;
  text-align: center;
}
.rzTop h1,
.aqTop h1 {
  margin: 50px 0;
}
.rzTop h1 span,
.aqTop h1 span {
  padding-bottom: 0;
  font-size: 37px;
  font-weight: 800;
}
.rzTop .rzp,
.aqTop .aqp {
  margin: 0 auto;
  width: 85vw;
  text-align: left;
  font-size: 26px;
  line-height: 40px;
}
.zzzsHeight {
  height: 70px;
}
.sjzxHeight {
  height: 70px;
}
.jtzlHeight {
  height: 70px;
}
.hover-content h1 {
  font-size: 22px;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 10px;
}
.gradient-background {
  padding: 0 85px 100px;
  border-top: 1px solid #000;
  width: 100%;
  height: 100%; /* 設置高度為視口高度 */
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.mailbg {
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.cpTop {
  margin: 90px 0 0 0;
  text-align: center;
}
.cpTop h1 {
  margin: 50px 0 0 0;
}
.cpTop h1 span {
  padding-bottom: 0px;
  font-size: 37px;
  font-weight: 800;
}

.jtzlImg {
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

div /deep/ .jtzlImg img {
  padding: 5px;
  width: 100%;
  overflow: hidden;
  height: 10vw;
  border: 0;
}
/* 榮譽圖片註釋設置 */
.slideImg {
  width: 100%;
  height: 450px;
  margin-bottom: -30px;
  padding-bottom: 30px;
}
.slideh2 {
  text-align: center;
  font-size: 30px;
  margin-top: 20px;
  margin-bottom: 15px;
}
.slideP {
  padding-top: 10px;
  font-size: 20px;
  line-height: 30px;
}
#cpzl,
#cpbz,
#aqzc {
  border-top: 1px solid #000;
}

.aqImg {
  width: 80vw;
}

.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
@media screen and (max-width: 1400px) {
  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan {
    font-size: 22px;
  }
  .slideImg {
    height: 170px;
  }
  .slideP {
    padding-top: 5px;
    font-size: 18px;
    line-height: 24px;
  }

  .xnytitle {
    font-size: 32px;
  }
  .rzTop h1 span,
  .cpTop h1 span {
    font-size: 25px;
  }
  .gradient-background {
    padding: 0 0 30px 0;
    background: white;
  }
  .mailbg {
    background: white;
  }

  .rzTop {
    margin: 15px 0;
  }
  .cpTop {
    margin: 0;
  }
  .rzTop h1,
  .cpTop h1 {
    margin: 30px 0;
  }
  .rzTop .rzp {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 19px;
    font-weight: 500;
    line-height: 20px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 10px;
  }

  .cpbzImg {
    height: 28vw;
  }
  .cpp {
    font-size: 18px;
    margin: 10px 0;
  }
  .container-fluid {
    margin: 15px 0;
  }
  .slideh2 {
    font-size: 24px;
  }
  .pzglImg {
    height: 45vw;
    margin: 10px 0;
  }
  .banner-info span {
    font-size: 30px;
  }
  .cbp-spmenu-push .banner {
    height: 350px;
  }
  .aqImg {
    width: 90vw;
  }
}

@media screen and (max-width: 768px) {
  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan {
    font-size: 22px;
  }
  .slideImg {
    height: 170px;
  }
  .slideP {
    padding-top: 5px;
    font-size: 13px;
    line-height: 20px;
  }

  .xnytitle {
    font-size: 32px;
  }
  .rzTop h1 span,
  .cpTop h1 span {
    font-size: 20px;
  }
  .gradient-background {
    padding: 0 0 30px 0;
    background: white;
  }
  .mailbg {
    background: white;
  }

  .rzTop {
    margin: 15px 0;
  }
  .cpTop {
    margin: 0;
  }
  .rzTop h1,
  .cpTop h1 {
    margin: 30px 0;
  }
  .rzTop .rzp {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 5px;
  }

  .cpbzImg {
    height: 28vw;
  }
  .cpp {
    font-size: 13px;
    margin: 10px 0;
  }
  .container-fluid {
    margin: 10px 0;
  }
  .slideh2 {
    font-size: 20px;
  }
  .pzglImg {
    height: 50vw;
    margin: 5px 0;
  }
  .banner-info span {
    font-size: 30px;
  }
  .cbp-spmenu-push .banner {
    height: 200px;
  }
  .aqImg {
    width: 90vw;
  }
}
@media screen and (min-width: 2000px) {
  .banner-info span {
    font-size: 65px;
  }
  .rzTop h1 span,
  .cpTop h1 span {
    font-size: 40px;
  }
  .rzTop .rzp {
    font-size: 29px;
    line-height: 1.5;
  }
  .slideh2 {
    font-size: 35px;
    margin: 50px 0 30px 0;
  }
  .slideP {
    font-size: 26px;
    line-height: 1.5;
  }
  .cpp {
    font-size: 26px;
  }
}
</style>
